import { RolesResponse } from 'api'
import api, { AxiosExceptUrl } from './api'

export const getRoles = (...args: AxiosExceptUrl<typeof api.get>) => {
  return api.get<RolesResponse>('/roles', ...args)
}
